import { useMemo } from "react";
import { Card, CardContent, Typography, Box, Stack, LinearProgress, Avatar } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";

const AVATAR_COLORS = ['#1976d2','#ed6c02','#2e7d32','#9c27b0','#d32f2f'];

export const RankingUsuarios = ({ data }) => {
  const ranking = useMemo(() => {
    const map = {};
    (data || []).forEach((r) => {
      const u = r.id_usuarios || 'N/A';
      map[u] = (map[u] || 0) + (parseInt(r.cantidad, 10) || 0);
    });
    return Object.entries(map)
      .map(([usuario, total]) => ({ usuario, total }))
      .sort((a, b) => b.total - a.total)
      .slice(0, 8);
  }, [data]);

  if (ranking.length === 0) return null;

  const max = ranking[0]?.total || 1;

  return (
    <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" mb={2}>
          <PeopleIcon color="primary" />
          <Typography variant="h6" fontWeight={700}>Ranking de usuarios</Typography>
        </Stack>

        <Stack spacing={1.5}>
          {ranking.map((r, i) => {
            const pct = Math.round((r.total / max) * 100);
            const avatarColor = AVATAR_COLORS[i % AVATAR_COLORS.length];

            return (
              <Box key={r.usuario}>
                <Stack direction="row" alignItems="center" spacing={1.5} mb={0.5}>
                  <Avatar
                    sx={{ width: 28, height: 28, fontSize: 12, fontWeight: 700, bgcolor: avatarColor }}
                  >
                    {i + 1}
                  </Avatar>
                  <Typography variant="body2" flex={1} fontWeight={i === 0 ? 700 : 500} noWrap>
                    Usuario {r.usuario}
                  </Typography>
                  <Typography variant="body2" fontWeight={600} color={avatarColor}>
                    {r.total.toLocaleString('es-AR')}
                  </Typography>
                </Stack>
                <LinearProgress
                  variant="determinate"
                  value={pct}
                  sx={{
                    height: 5,
                    borderRadius: 3,
                    ml: '43px',
                    '& .MuiLinearProgress-bar': { bgcolor: avatarColor },
                  }}
                />
              </Box>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
};
